import type { FaireProductEntity } from "../../entity_types/product";

export const p_u45n3urp45: FaireProductEntity = {
  token: "p_u45n3urp45",
  type: "product",
  name: "Olivetti Lettera Collection: 12 Notecards and Envelopes",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/1801b69e343a9265f9f58d280353defbb5f6fc7bbd6132b260c48b3f9f3bcdae.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/051ac67869d4671db15e4764a323d9b6c8fb1848d5b8022c4b116234721d4dae.jpeg",
    "https://cdn.faire.com/fastly/3aa8b6a489dc57c9b538ca413d70811c200e027e30672ccdb056395075f647b6.jpeg",
    "https://cdn.faire.com/fastly/44b1b0581a79318d39579de3df68d03b812a60560897e18dbaa60ea8d17b1dd3.jpeg",
    "https://cdn.faire.com/fastly/cfba89cb46178256a43fc038a30db0b455ba0b07df5bf956aa90b05ac2d253eb.jpeg",
    "https://cdn.faire.com/fastly/f1183ea94d2af7c3b2283eb5f681635fadea5836cd5990e1e79e503f769f6db9.jpeg",
    "https://cdn.faire.com/fastly/a34701d4fbd31a7522f8e2184c9ae8b8109d4d1870ef919165d24629cc93aa5c.jpeg",
    "https://cdn.faire.com/fastly/78216815075aabade037ba99b88ca481f0354ba4fa5b4ff658e21c6a1942478a.jpeg"
  ],
  priceDollars: 10,
  description: "Discover the new release that features a series of beautifully illustrated cards, perfect for anyone who appreciates art and design. This unique collection captures the essence of Olivetti's legacy as a renowned Italian manufacturer, known for merging creativity with technology. The cards are not just functional but also serve as a delightful showcase for the meticulous attention to design that Olivetti has been celebrated for since its inception in 1908. Whether you're looking to spark inspiration, send a heartfelt message, or simply enjoy stunning artwork, this collection is an excellent choice to elevate your stationery game.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:39.540Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
